import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "./i18n/LangContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Capabilities from "./pages/Capabilities";
import Sectors from "./pages/Sectors";
import About from "./pages/About";
import Contact from "./pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/solutions" element={<Capabilities />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/sectors" element={<Sectors />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0A1128",
                color: "#F7F4EC",
                border: "1px solid #C5B358",
                fontFamily: "IBM Plex Sans, sans-serif",
                borderRadius: "0",
              },
            }}
          />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
